import React, { Component, Fragment } from "react";
import MultiLine from "../../../../../d3Components/MultiLineChart/multiLine";
import Legendhtml from "../../../../../d3Components/MultiLineChart/Legendhtml";
import Helper from "../../helper";
import ContainerDimensions from "react-container-dimensions";

class MultiLineHolder extends Component {
  state = {
    seriesOptionsA: []
  };
  componentDidMount() {
    const { res } = this.props;
    this.setState({
      seriesOptionsA: Helper.assetFormatData(res)
    });
  }
  componentWillReceiveProps(nextProps) {
    const { res } = nextProps;
    this.setState({
      seriesOptionsA: Helper.assetFormatData(res)
    });
  }
  render() {
    const { seriesOptionsA } = this.state;

    return (
      <div className="row">
        <div style={{ overflowX: "auto" }}>
          {seriesOptionsA.length > 0 ? (
            <ContainerDimensions>
              {({ width }) => (
                <Fragment>
                  {width > 0 ? (
                    <MultiLine
                      data={seriesOptionsA}
                      id={"multi1"}
                      lineStyle={"Multiline1"}
                      circleStyle={"Circle1"}
                      width={width - 50}
                    />
                  ) : null}
                </Fragment>
              )}
            </ContainerDimensions>
          ) : null}
        </div>

        {seriesOptionsA.length > 0 ? (
          <ContainerDimensions>
            {({ width }) => (
              <Fragment>
                {width > 0 ? (
                  <Legendhtml
                    data={seriesOptionsA}
                    legendId={"MultilineLegend1"}
                    width={width}
                  />
                ) : null}
              </Fragment>
            )}
          </ContainerDimensions>
        ) : null}
      </div>
    );
  }
}

export default MultiLineHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/AssetClass/section1/multilineHolder.jsx